import style from './index.module.less';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
    const navigate = useNavigate();

    const goToHomepage = () => {
        navigate('/workbench');
    };

    return (
        <div className={style.notFound}>
            <div className={style.notFoundContent}>
                <div className="h-black-99">当前页面不存在</div>
                <button 
                    className={style.homeButton} 
                    onClick={goToHomepage}
                >
                    回到首页
                </button>
            </div>
        </div>
    );
}
